<script setup>
  import { useUserStore } from "@/stores/UserStore";
  import Icon from "@/components/icons/Icon.vue";

  const props = defineProps({
    tideSpot: {
      type: Object,
      required: true
    }
  });

  const userStore = useUserStore();

</script>

<template>
  <div class="jwx-tide-spot-selector__type-indicator">
    <div class="jwx-tide-spot__type-indicator" :data-spot-type="props.tideSpot.type">
      <Icon v-if="props.tideSpot.type === 'tide'" name="tide-spot" class="jwx-tide-spot__type-indicator-icon" />
      <Icon v-else name="currents-spot" class="jwx-tide-spot__type-indicator-icon" />
    </div>
  </div>
  <div class="jwx-tide-spot-selector__location">
    <div class="jwx-tide-spot-selector__name">{{ props.tideSpot.name }}</div>
    <div class="jwx-tide-spot-selector__region">{{ props.tideSpot.region }}</div>
    <div class="jwx-tide-spot-selector__distance">{{ props.tideSpot.distance }} {{ userStore.units.distance }}</div>
  </div>
</template>